(() => {
  const sizeMap = {
    '6': 'XS / UK 6', '8': 'S / UK 8', '10': 'M / UK 10–12', '12': 'M / UK 10–12',
    '14': 'L / UK 14', '16': 'XL / UK 16', '18': '2XL / UK 18',
    '20': '3XL / UK 20–22', '22': '3XL / UK 20–22',
    '24': '4XL / UK 24–26', '26': '4XL / UK 24–26',
    '28': '5XL / UK 28–30', '30': '5XL / UK 28–30'
  };

  function updateFit(select) {
    const root = select.closest('[data-kijn-fit-tool]');
    if (!root) return;
    const output = root.querySelector('[data-kijn-fit-result]');
    if (output) output.textContent = sizeMap[select.value] || 'Choose your usual UK size';
  }

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-kijn-size-select]')) updateFit(event.target);
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-kijn-size-select]').forEach(updateFit);
  });
})();
